module.exports = __webpack_public_path__ + "img/team_develop.6ab547b9.svg";